import type {SortingStrategy} from '../types';

export const rectSwappingStrategy: SortingStrategy = ({
  activeIndex,
  index,
  rects,
  overIndex,
}) => {
  let oldRect;
  let newRect;

  if (index === activeIndex) {
    oldRect = rects[index];
    newRect = rects[overIndex];
  }

  if (index === overIndex) {
    oldRect = rects[index];
    newRect = rects[activeIndex];
  }

  if (!newRect || !oldRect) {
    return null;
  }

  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height,
  };
};



// WEBPACK FOOTER //
// ../src/strategies/rectSwapping.ts